import React, {useContext} from 'react';
import 'index.css';
import Button from '@material-ui/core/Button';
import BookButton from 'components/BookButton';
import _ from 'lodash';
import {useTranslation} from 'react-i18next';
import Context from 'utils/Context';

const PayButton = ({seance, onPay, showAccess}) => {
  const {t} = useTranslation();
  const {methods, goTo, ed, appState} = useContext(Context);

  const hasAccess =
    appState.user.mes_seances && _.findIndex(appState.user.mes_seances, {seance_id: seance.seance_id}) !== -1;

  if ((!seance.local && showAccess && hasAccess) || (seance.local && hasAccess)) {
    return (
      <Button
          disabled={seance.ended}
          className="seance-btn"
          color="primary"
          size="small"
          variant="contained"
          onClick={() => goTo('/seance/' + seance.seance_id)}
        >
          {t('acceder-a-la-seance')}
        </Button>
    );
  }

  if (!seance.local || seance.billetterie !== 1) return null;

  if (seance.access_by_promo_code_only) {
    return (
      <Button
        disabled={seance.cantBuy}
        className="seance-btn"
        color="primary"
        size="small"
        variant="contained"
        onClick={onPay}
      >
        {t('reserver')}
      </Button>
    );
  }

  if (parseFloat(seance.prix) === 0) {
    return <BookButton seance={seance} appState={appState} methods={methods} ed={ed} />;
  }

  if (parseFloat(seance.prix) > 0) {
    return (
      <Button
        disabled={seance.cantBuy}
        className="seance-btn"
        color="primary"
        size="small"
        variant="contained"
        onClick={onPay}
      >
        {`${t('acheter')} ${seance.prix} ${appState.conf.CURRENCY_SYMBOL}`}
      </Button>
    );
  }

  return null;
};

export default PayButton;
